import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsGuardianNotificationSendParm } from "./wsGuardianNotificationSendParm";
import { PersonRegisteredUsersRequest } from "./PersonRegisteredUsersRequest";

@Injectable()
export class DataService_guardiannotification {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationInfoGet
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationInfoGet(PersonID: number) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianNotificationInfoGet";

		var promise$ = this.httpclientService.post(url, PersonID);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	GuardianNotificationSendNotification
	//
	//-----------------------------------------------------------------------------------------------------
	GuardianNotificationSendNotification(parms: wsGuardianNotificationSendParm) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/GuardianNotificationSendNotification";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotifyLanguageSelectList() {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/NotifyLanguageSelectList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	NotifyLanguageModify(PersonID, NotifyLanguageID) {
		var postResult$ = new Subject();
		var url = "StudentGuardianNotification/NotifyLanguageModify?PersonID=" + PersonID + "&NotifyLanguageID=" + NotifyLanguageID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PersonRegisteredUsersSelectList(parms: PersonRegisteredUsersRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PersonRegisteredUsersSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
